import { Entity } from "../Types";

interface FetchSinceResult<T> {
    since: string;
    data: T[];
    activeItems: T[];
    deletedItems: T[];
    badgeItems: number[];
}

export function processFetchSinceData<T extends Entity>(
    data: T[] | undefined,
    payloadSince?: string
): FetchSinceResult<T> {
    const since = payloadSince || new Date().toISOString();
    const resultData = data ?? [];

    const activeItems: T[] = [];
    const deletedItems: T[] = [];
    const badgeItems: number[] = [];

    resultData.forEach(item => {
        if (item.deletedAt) {
            deletedItems.push(item);
        } else {
            activeItems.push(item);
            badgeItems.push(item.id as number);
        }
    });

    return {
        since,
        data: resultData,
        activeItems,
        deletedItems,
        badgeItems
    };
}
